import { Component, ElementRef, EventEmitter, Input, OnChanges, OnInit, Output, SimpleChanges, ViewChild } from '@angular/core';
import { SharedService } from '../../shared.service';
import { TypingInterval } from 'src/app/constants';

@Component({
  selector: 'app-search-box',
  templateUrl: './search-box.component.html',
  styleUrls: ['./search-box.component.scss']
})
export class SearchBoxComponent implements OnInit, OnChanges {

  @Input() fromComponent: string;

  @Input() sectionName: string;

  @Input() typingInterval: number;

  @Input() clearSearchText: boolean;

  @Output() searchTypeEvent = new EventEmitter();

  @ViewChild('myInputElement') myInputElement!: ElementRef;

  idString = '';

  searchText = '';

  typingTimer: any;

  doneTypingInterval: number;

  constructor(private sharedService: SharedService) { }

  ngOnInit(): void {
    this.doneTypingInterval = this.getTypingInterval();
    this.idString = this.sharedService.createIdString(this.fromComponent, this.sectionName, 'search');
  }

  getTypingInterval() {
    if (this.typingInterval) {
      return this.typingInterval;
    } else if (this.typingInterval === 0) {
      return 0;
    }
    return TypingInterval
  }

  doneTyping(searchText: string) {
    // console.log('User has finished typing. Input value:', searchText);
    this.searchTypeEvent.emit(this.searchText);
    // Add your desired action here, e.g., trigger a search, validate input, etc.
  }

  inputKeyUp(event: any) {
    clearTimeout(this.typingTimer);
    // console.log(event.target.value);
    // this.searchText = event.target.value ? event.target.value : '';
    // if (this.searchText) {
    this.typingTimer = setTimeout(() => {
      this.doneTyping(this.searchText)
    }, this.doneTypingInterval);
    // }
  }

  // optional
  inputKeyDown(event: any) {
  }

  onMouseOver() {
    this.myInputElement.nativeElement.focus();
  }

  onMouseLeave() {
    this.myInputElement.nativeElement.blur();
  }

  ngOnChanges(changes: SimpleChanges): void {
    if(this.clearSearchText) {
      this.searchText = '';
    }
  }


}
